var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F44336;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,60.7l56-56C63.8,1.6,67.9,0,72,0s8.2,1.6,11.3,4.7l40,40c6.3,6.2,6.3,16.4,0,22.6l-56,56 c-3.1,3.1-7.2,4.7-11.3,4.7H8c-2.1,0-4.2-0.8-5.7-2.3c-1.3-1.3-2.3-3-2.3-4.8V73.3C0,68.8,1.2,64.1,4.6,60.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,82.8c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8S8.2,112,8.2,101.6S16.6,82.8,27,82.8z M17.6,101.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,66.3l11.1-11.1c-2.5-4.5-3.5-8.5-3.1-12.1c0.4-3.6,2-6.9,4.9-9.8c2.9-2.9,6.3-4.4,10.1-4.6 c3.8-0.1,7.4,1.2,10.7,3.9l2.6-2.6l3.9,3.9l-2.6,2.6c2.5,3.2,3.8,6.4,3.8,9.6c0.1,3.3-1,6.4-3.2,9.6l-7.6-5.8c1.7-2.5,2-5,1.1-7.4 L79.3,52.7c3.1,5.4,4.5,9.8,4.2,13.2c-0.3,3.4-1.9,6.5-4.7,9.4c-3.2,3.2-6.9,4.9-11,5.2c-4.1,0.3-8.2-1.1-12.1-4.1l-5,5l-3.9-3.9 l4.8-4.8c-2.7-3.4-4-7.1-4-10.9c0-3.8,1.5-7.8,4.4-11.8l7.7,6.2c-1.1,1.7-1.8,3.5-2.1,5.3C57.4,63.3,57.5,64.9,58,66.3z M61.5,70.5 c1.6,1.1,3.3,1.5,5.1,1.4c1.8-0.2,3.4-0.9,4.7-2.2c1.2-1.2,1.9-2.6,2-4.1c0.2-1.6-0.3-3.4-1.5-5.4L61.5,70.5z M85.9,38.4 c-1.4-0.7-2.8-0.9-4.3-0.7c-1.5,0.2-2.7,0.9-3.7,1.9c-0.9,0.9-1.5,2.1-1.8,3.5c-0.2,1.4,0,2.9,0.6,4.5L85.9,38.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount1);
export default __webpack_public_path__ + "static/media/Discount1.dfd593aaeb73dcb067957881659ac970.svg";
export { ForwardRef as ReactComponent };